// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader@6.11.0_@rspack+core@1.0.0_@swc+helpers@0.5.12__webpack@5.94.0_@swc+core@1.9.3_@swc+helpers@0.5.12__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader@6.11.0_@rspack+core@1.0.0_@swc+helpers@0.5.12__webpack@5.94.0_@swc+core@1.9.3_@swc+helpers@0.5.12__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* base styles */

._GzYRV {
  line-height: 1.2;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}

._3eOF8 {
  margin-right: 5px;
  font-weight: bold;
}

._1MFti {
  cursor: pointer;
}

._f10Tu {
  font-size: 1.2em;
  margin-right: 5px;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

._1UmXx::after {
  content: '\\25B8';
}

._1LId0::after {
  content: '\\25BE';
}

._1pNG9 {
  margin-right: 5px;
}

._1pNG9::after {
  content: '...';
  font-size: 0.8em;
}

._2IvMF {
  background: #eee;
}

._2bkNM {
  margin: 0 10px;
  padding: 0;
}

/* default light style */
._1MGIk {
  font-weight: 600;
  margin-right: 5px;
  color: #000000;
}

._2YKJg {
}

._3uHL6 {
  color: #000000;
}

._2T6PJ {
  color: #df113a;
}

._1Gho6 {
  color: #df113a;
}

._vGjyY {
  color: rgb(42, 63, 60);
}

._1bQdo {
  color: #0b75f5;
}

._3zQKs {
  color: rgb(70, 144, 56);
}

._1xvuR {
  color: #43413d;
}

._oLqym {
  color: #000000;
}

._2AXVT {
  color: #000000;
}

._2KJWg {
  color: #000000;
}

/* default dark style */
._11RoI {
  background: rgb(0, 43, 54);
}

._17H2C {
  color: rgb(253, 246, 227);
}

._3QHg2 {
  color: rgb(253, 246, 227);
}

._3fDAz {
  color: rgb(253, 246, 227);
}

._2bSDX {
  font-weight: bolder;
  margin-right: 5px;
  color: rgb(253, 246, 227);
}

._1RQEj {
}

._gsbQL {
  color: rgb(253, 246, 227);
}

._LaAZe {
  color: rgb(129, 181, 172);
}

._GTKgm {
  color: rgb(129, 181, 172);
}

._Chy1W {
  color: rgb(203, 75, 22);
}

._2bveF {
  color: rgb(211, 54, 130);
}

._2vRm- {
  color: rgb(174, 129, 255);
}

._1prJR {
  color: rgb(38, 139, 210);
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/.pnpm/react-json-view-lite@1.4.0_react@18.3.1/node_modules/react-json-view-lite/dist/index.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;AACA;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;AACA;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* base styles */\n\n._GzYRV {\n  line-height: 1.2;\n  white-space: pre-wrap;\n  white-space: -moz-pre-wrap;\n  white-space: -pre-wrap;\n  white-space: -o-pre-wrap;\n  word-wrap: break-word;\n}\n\n._3eOF8 {\n  margin-right: 5px;\n  font-weight: bold;\n}\n\n._1MFti {\n  cursor: pointer;\n}\n\n._f10Tu {\n  font-size: 1.2em;\n  margin-right: 5px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n._1UmXx::after {\n  content: '\\25B8';\n}\n\n._1LId0::after {\n  content: '\\25BE';\n}\n\n._1pNG9 {\n  margin-right: 5px;\n}\n\n._1pNG9::after {\n  content: '...';\n  font-size: 0.8em;\n}\n\n._2IvMF {\n  background: #eee;\n}\n\n._2bkNM {\n  margin: 0 10px;\n  padding: 0;\n}\n\n/* default light style */\n._1MGIk {\n  font-weight: 600;\n  margin-right: 5px;\n  color: #000000;\n}\n\n._2YKJg {\n}\n\n._3uHL6 {\n  color: #000000;\n}\n\n._2T6PJ {\n  color: #df113a;\n}\n\n._1Gho6 {\n  color: #df113a;\n}\n\n._vGjyY {\n  color: rgb(42, 63, 60);\n}\n\n._1bQdo {\n  color: #0b75f5;\n}\n\n._3zQKs {\n  color: rgb(70, 144, 56);\n}\n\n._1xvuR {\n  color: #43413d;\n}\n\n._oLqym {\n  color: #000000;\n}\n\n._2AXVT {\n  color: #000000;\n}\n\n._2KJWg {\n  color: #000000;\n}\n\n/* default dark style */\n._11RoI {\n  background: rgb(0, 43, 54);\n}\n\n._17H2C {\n  color: rgb(253, 246, 227);\n}\n\n._3QHg2 {\n  color: rgb(253, 246, 227);\n}\n\n._3fDAz {\n  color: rgb(253, 246, 227);\n}\n\n._2bSDX {\n  font-weight: bolder;\n  margin-right: 5px;\n  color: rgb(253, 246, 227);\n}\n\n._1RQEj {\n}\n\n._gsbQL {\n  color: rgb(253, 246, 227);\n}\n\n._LaAZe {\n  color: rgb(129, 181, 172);\n}\n\n._GTKgm {\n  color: rgb(129, 181, 172);\n}\n\n._Chy1W {\n  color: rgb(203, 75, 22);\n}\n\n._2bveF {\n  color: rgb(211, 54, 130);\n}\n\n._2vRm- {\n  color: rgb(174, 129, 255);\n}\n\n._1prJR {\n  color: rgb(38, 139, 210);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
